export default function StatsForm() {

    return (
        <> </>
    );
}